import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Topbar from "../topbar/Topbar";
import Sidebar from "../sidebar/Sidebar";
import ModalLoader from "../ModalLoader";
import { toast } from "react-toastify";
import { URLS } from "../urls";
import {
  fetchActionsUtil,
  statusColor,
  stringifyQueryString,
  useCookie,
  arrangeEventObject,
} from "../../utils";
import moment from "moment";
import TableComponent from "../TableComponent";

import "./attendance.css";
import { CalendarTodayOutlined } from "@mui/icons-material";
import NoTableItem from "../NoTableItem";
import { UseQueryData } from "../UseQueryData";
import CustomPagination from "../Paginations";
import RsDateRangePicker from "../RsDateRangePicker";
import { DownArrowIcon } from "../icons";

function MyAttendance() {
  // ------------------ Filter Search -------------------//
  const initialQueryParams = {
    limit: 20,
    page: 1,
    status: "",
    startDate: "",
    endDate: "",
  };
  const { queryParams, theQueryParams, onChangeInput, setQueryParams } =
    UseQueryData({
      initialQueryParams,
      timer: 1500,
    });
  // ------------------ Filter Search -------------------//

  const [returnParams, setReturnParams] = useState({
    count: 0,
    endIndex: 0,
    startIndex: 0,
  });

  const userId = useCookie("userId");
  const [loading, setLoading] = useState(false);
  const [showAttendance, setShowAttendance] = useState([]);
  const [chooseStatus, setChooseStatus] = useState([]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getAttendance();
    }

    return () => {
      isMounted = false;
    };
  }, [queryParams, userId]);

  const getAttendance = async () => {
    try {
      setLoading(true);

      const result = await fetchActionsUtil(
        `${
          URLS.backendattendance
        }/get-employee-attendance?userId=${userId}&${stringifyQueryString({
          ...queryParams,
        })}`
      );

      setShowAttendance(result?.attendance);
      setChooseStatus(result?.uniqueStatus);

      setReturnParams({
        count: result?.count,
        endIndex: result?.endIndex,
        startIndex: result?.startIndex,
      });
    } catch (error) {
      console.log(error);

      toast("Error Occurred", {
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const onRowClick = (attendance) => {};

  const tableHead = () => {
    return (
      <thead className="table">
        <tr>
          <th>No</th>
          <th>Employee ID </th>
          <th>Employee Name </th>
          <th>Date </th>
          <th>Clock In</th>
          <th>Clock Time</th>
          <th>Status</th>
          <th>Remarks</th>
           <th>Source</th>
        </tr>
      </thead>
    );
  };

  const tableBodyData = (attendance, index) => {
    return (
      <>
        <td>{index + 1}</td>
        <td>{attendance?.employeeId}</td>
        <td>
          {attendance?.userId?.personalInfo?.name?.first ||
            attendance?.employeeName ||
            ""}{" "}
          {attendance?.userId?.personalInfo?.name?.last || ""}
        </td>
        <td className="d-flex gap-3 align-items-center">
          <span>
            <CalendarTodayOutlined fontSize="small" />
          </span>
          <p>{moment(attendance?.date)?.format("MMMM Do YYYY")}</p> <p></p>
        </td>
        <td>
          <span>
            {attendance?.clockIn?.createdAt
              ? moment(
                  attendance?.clockIn?.createdAt,
                  "YYYY-MM-DD HH:mm"
                ).format("HH:mm")
              : "--"}
          </span>
          {"  "}
          {attendance?.clockIn?.createdAt ? (
            <small
              className={`tw-status ${statusColor(
                attendance?.clockIn?.status === "approved"
                  ? "green"
                  : attendance?.clockIn?.status === "pending"
                  ? "orange"
                  : "red"
              )}`}
            >
              {attendance?.clockIn?.status}
            </small>
          ) : (
            "--"
          )}
        </td>
        <td>
          <span>
            {attendance?.clockOut?.createdAt
              ? moment(
                  attendance?.clockOut?.createdAt,
                  "YYYY-MM-DD HH:mm"
                ).format("HH:mm")
              : "--"}
          </span>
          {"  "}
          {attendance?.clockOut?.createdAt ? (
            <small
              className={`tw-status ${statusColor(
                attendance?.clockOut?.status === "approved"
                  ? "green"
                  : attendance?.clockOut?.status === "pending"
                  ? "orange"
                  : "red"
              )}`}
            >
              {attendance?.clockOut?.status}
            </small>
          ) : (
            "--"
          )}
        </td>
        <td>
          <p
            className={`tw-status ${statusColor(
              attendance.status === "approved" ? "green" : "orange"
            )}`}
          >
            {attendance?.status}
          </p>
        </td>
        <td>{attendance?.remarks}</td>
        <td>{attendance?.remarks?.split("")[0] === "Attendance" ? attendance?.remarks : "Attendance from app"}</td>
      </>
    );
  };

  const dropDownFunction = (qty) => {
    setQueryParams((el) => ({ ...el, limit: qty }));
  };

  const filterByDateRange = (event, picker) => {
    onChangeInput(
      arrangeEventObject({
        name: "startDate",
        value: picker.startDate,
      })
    );

    onChangeInput(
      arrangeEventObject({
        name: "endDate",
        value: picker.endDate,
      })
    );

    picker.element.val(
      picker.startDate.format("DD-MM-yyyy") +
        " - " +
        picker.endDate.format("DD-MM-yyyy")
    );
  };

  const clearDateRange = (event, picker) => {
    onChangeInput(
      arrangeEventObject({
        name: "startDate",
        value: "",
      })
    );

    onChangeInput(
      arrangeEventObject({
        name: "endDate",
        value: "",
      })
    );

    picker.element.val("");
  };

  return (
    <body>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex, nofollow"></meta>
        <title>InvexERP</title>
      </Helmet>
      <div className="main-wrapper">
        <Topbar />
        <Sidebar />
        <section className="bg-white page-header position-relative w-100 page-header-2">
          <div className="page-wrapper">
            <div className="d-flex w-100  m-0 p-0 align-items-center justify-content-between gap-5">
              <div className="">
                <h4 className="page-title page-title-alt">My Attendance</h4>
                <p className="page-paragraph">Personal attendance</p>
              </div>
            </div>
          </div>
        </section>
        {/*<!-- Page Wrapper -->*/}
        <div className="page-wrapper  mt-n10">
          {/*<!-- Page Content -->*/}
          <div className="content container-fluid">
            {/*<!-- Page Title -->*/}

            {/*<!-- /Page Title -->*/}
            {/*<!-- Content Starts -->*/}

            <div className="p-3">
              <div className="">
                <div className="grid-cat-1 filter-row">
                  <div className="form-group form-focus text-gray-400 d-flex align-items-center justify-content-between">
                    <select
                      className="form-control floating"
                      value={theQueryParams.status}
                      name="status"
                      onChange={(e) => onChangeInput(e)}
                    >
                      <option selected value="">
                        Select status
                      </option>
                      {chooseStatus?.map((name) => (
                        <option value={name}>{name}</option>
                      ))}
                    </select>
                    <div className=" pr-2">
                      <DownArrowIcon color="#6c757d" />
                    </div>
                  </div>

                  <div>
                    <div className="search-date cal-icon">
                      <RsDateRangePicker
                        placement="bottomEnd"
                        onClean={(event, picker) =>
                          clearDateRange(event, picker)
                        }
                        onOk={(event, picker) =>
                          filterByDateRange(event, picker)
                        }
                        placeholder="Select From and To Date"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                {/*<!-- JobGradeHistory Table -->*/}
                <div className="info">
                  <div className="table-height">
                    {showAttendance?.length > 0 ? (
                      <TableComponent
                        responsive
                        borderless
                        // striped
                        sticky
                        // hover
                        tableHeadsFunction={tableHead}
                        mainDataArray={showAttendance}
                        tableDataRowFunction={tableBodyData}
                        className="product-table text-nowrap"
                        onDoubleClickRow={onRowClick}
                      />
                    ) : (
                      <NoTableItem />
                    )}
                  </div>
                </div>
                {/*<!-- Table --> */}
              </div>
            </div>

            {/*<!-- /Content End -->*/}

            <div className="my-4">
              <CustomPagination
                setQueryParams={setQueryParams}
                startIndex={returnParams.startIndex}
                endIndex={returnParams.endIndex}
                count={returnParams.count}
                limit={queryParams.limit}
                page={queryParams.page}
                dropDownFunction={dropDownFunction}
              />
            </div>
          </div>
          {/*<!-- /Page Content -->*/}
        </div>
        {/*<!-- /Page Wrapper -->*/}
      </div>
      {/*<!-- /Main Wrapper -->*/} {/* <!-- Sidebar Overlay --> */}
      <div className="sidebar-overlay" data-reff=""></div>
      <ModalLoader show={loading} />
    </body>
  );
}

export default MyAttendance;
